import {  useRemoteClientPost } from '@/configs/http-client';
import { Endpoints } from '@/remote/endpoints';
import { useLocalStorage } from '@/remote/local-storage';
import { DataTableEmployee } from '@/view/components/data-table-employee-gym';
import { PaginationDemo } from '@/view/components/pagination';
import { usePagination } from '@/view/hooks';
import { usePromiseToast } from '@/view/hooks/toast-promisse';
import { EmployeeData } from '@/view/validators/employee-form-validator';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';



export function DisplayEmployeeGym() {
  const { httpClientPost } = useRemoteClientPost()
  const { triggerToast } = usePromiseToast()
  const { backPage, nextPage } = usePagination()
  const { getUnitId } = useLocalStorage()
  const [params] = useSearchParams()
  const [data, setData] = useState<EmployeeData[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [pageInfo, setPageInfo] = useState({
    page: 0,
    total: 0,
    totalPages: 0
  })
  const quantityForPage = 20

  const updatePageInfo = (responseData: any) => {
    const content = responseData?.content ?? []
    const page = responseData?.pageable?.pageNumber ?? 0
    const totalPages = responseData?.totalPages ?? 0
    const total = responseData?.totalElements ?? 0

    setData(content)
    setPageInfo({
      page,
      total,
      totalPages
    })
  }

  const fetchData = async () => {
    try {
      setIsLoading(true)
     const response = await httpClientPost(
        `${Endpoints.employee}/filtro?page=${pageInfo.page}&size=${quantityForPage}&order=desc&sort=id`,
        {
          unidadeId: params.get("id") ?? getUnitId(),
          status: 1,
        },
      )
      updatePageInfo(response?.data?.data)
    } catch (error) {
      console.error('Erro ao buscar dados:', error)
      throw error
    } finally {
      setIsLoading(false)
    }
  }

  const handlePageNavigation = (newPage: number) => {
    if (newPage >= 0 && newPage < pageInfo.totalPages) {
      setPageInfo(prev => ({ ...prev, page: newPage }))
    }
  }

  const handleNextPage = () => {
    nextPage(pageInfo.page, pageInfo.totalPages, (newPage) => {
      handlePageNavigation(newPage)
    })
  }

  const handlePreviousPage = () => {
    backPage(pageInfo.page, (newPage) => {
      handlePageNavigation(newPage)
    })
  }

  const handleRefresh = () => {
    triggerToast(fetchData())
  }

  useEffect(() => {
    handleRefresh()
  }, [pageInfo.page, params])

  return (
    <div className="space-y-4">
      {isLoading ? (
        <div className="flex justify-center py-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500" />
        </div>
      ) : (
        <>
          <DataTableEmployee
            data={data}
            getRefreshList={handleRefresh}
          />

          {data.length > 0 && (
            <PaginationDemo
              totalForPage={quantityForPage}
              back={handlePreviousPage}
              next={handleNextPage}
              page={pageInfo.page}
              total={pageInfo.total}
              labelItem='funcionários'
            />
          )}
        </>
      )}
    </div>
  )
}